import React, {useLayoutEffect, useState, useEffect} from 'react';
import { Link, useNavigate } from 'react-router-dom';

async function checkUserDeviceConnected() {
    const response = await fetch('/api/check-user-device-conneted', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    const status = await response.json();
    return status[0];
}

function DashboardError() {
   const client_version = process.env.REACT_APP_CLIENT_VERSION;

   const navigate = useNavigate();
   const [isReady, setIsReady] = useState(false);

   useLayoutEffect(() => {
      const startDashboard = async () => {
         if (await checkUserDeviceConnected()) {
               navigate('/dashboard')
         }

         setIsReady(true);
      };

      startDashboard();
      
   }, [navigate])

   useEffect(() => {
      const interval = setInterval(async () => {
         if (await checkUserDeviceConnected()) {
            navigate('/dashboard')
         }
      }, 10000);

      return () => clearInterval(interval);
   }, [navigate]);

   const handleDownload = async () => {
      window.location.assign('/downloads/LiveTelemetry.exe');
   };

   if (isReady) {
      return (
          <>
            <div className="block md:hidden text-center p-10">
                <h1>Ops!</h1>
                <p>This platform is only available on PC for optimal graph viewing.</p>
            </div>

            <div className="hidden md:block">
               <div className="relative flex h-auto min-h-screen w-full flex-col group/design-root overflow-x-hidden carbon-pattern">
                  <header className="flex items-center justify-between whitespace-nowrap border-b border-solid border-slate-200 dark:border-slate-800 bg-white/5 backdrop-blur-md px-10 py-3 sticky top-0 z-50">
                        <div className="flex items-center gap-4">
                        <div className="size-8 bg-primary rounded flex items-center justify-center text-white">
                           <span className="material-symbols-outlined">speed</span>
                        </div>
                        <Link to='/'><h2 className="text-white text-lg font-bold leading-tight tracking-tight uppercase">ACCLiveTelemetry</h2></Link>
                        </div>
                        <div className="flex flex-1 justify-end gap-8">
                        <div className="flex items-center gap-4">
                           <div className="bg-center bg-no-repeat aspect-square bg-cover rounded-full size-10 border border-slate-700" data-alt="User avatar placeholder" style={{backgroundImage: 'url("https://lh3.googleusercontent.com/aida-public/AB6AXuArO0qEtv-n92WMyozAp7gp7GB2c4w7KGK9eTRCtBqcTeZjfpBWt2-NUI1NCbBMaNaW1Gfp_tNtbLilW2LHq-14yzkuKtDNaBAhY35u0C_0ykcKsbG2pNA9Vav_kqMlM-c-p2UUp89pcFKlXw9UJbRGJVBs2-g_3w8AMf6khN77Z5nqAj9rNQALn_Dsxq1KewAorHXBR2D2vGSKqXwyHhNowf2YH1WMdATg9J7Ddy6YR7UjAYVXH6loBdCnxhTvxPeVzUgXr5sntz0")'}}></div>
                        </div>
                        </div>
                  </header>
               <main className="flex-1 flex flex-col max-w-[1400px] mx-auto w-full p-6 md:p-12">
                  <div className="mb-10">
                     <div className="flex items-center gap-2 mb-2">
                        <span className="size-2 rounded-full bg-red-500 animate-pulse"></span>
                        <span className="text-xs font-bold text-red-500 uppercase tracking-widest">System Offline</span>
                     </div>
                     <h1 className="text-white text-5xl font-black leading-tight tracking-tighter">SETUP REQUIRED</h1>
                     <p className="text-slate-400 text-lg max-w-2xl mt-2 font-light">Link your local simulator data to our cloud infrastructure to unlock real-time lap analysis and global leaderboards.</p>
                  </div>
                  <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
                     <div className="lg:col-span-7 flex flex-col gap-6">
                        <div className="bg-surface-dark/80 border border-slate-800 rounded-xl p-8 backdrop-blur-sm">
                           <div className="flex flex-col md:flex-row gap-8 items-center">
                              <div className="w-full md:w-1/3 aspect-square bg-slate-900 rounded-lg flex items-center justify-center border border-slate-800">
                                 <span className="material-symbols-outlined text-primary text-7xl">settings_input_component</span>
                              </div>
                              <div className="flex-1">
                                 <h3 className="text-2xl font-bold text-white mb-3">Download Local Sync Client</h3>
                                 <p className="text-slate-400 mb-6 leading-relaxed">The sync client bridges the gap between Assetto Corsa Competizione and our telemetry engine. It has zero impact on FPS and runs quietly in the system tray.</p>
                                 <div className="flex flex-wrap gap-3">
                                    <button onClick={handleDownload} className="flex-1 flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-white font-bold py-4 px-6 rounded-lg transition-all neon-glow">
                                       <span className="material-symbols-outlined">download</span>
                                       Download for Windows
                                    </button>
                                 </div>
                                 <p className="text-slate-500 text-xs mt-4 italic font-light">Current Version: {client_version} | Requires Steam Version of ACC</p>
                              </div>
                           </div>
                        </div>

                        <div className="bg-surface-dark/40 border border-slate-800 rounded-xl p-8">
                           <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-8 text-primary/80">3-Step Installation Flow</h4>
                           <div className="grid grid-cols-1 md:grid-cols-3 gap-4 relative">

                              <div className="flex flex-col gap-3 relative z-10">
                                 <div className="size-10 rounded-full bg-primary flex items-center justify-center text-white font-bold">1</div>
                                 <div>
                                    <p className="text-white font-bold">Download Client</p>
                                    <p className="text-slate-400 text-sm">Install the application to your local drive.</p>
                                 </div>
                              </div>

                              <div className="flex flex-col gap-3 relative z-10">
                                 <div className="size-10 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center text-slate-500 font-bold">2</div>
                                 <div>
                                    <p className="text-slate-400 font-bold">Link Your Account</p>
                                    <p className="text-slate-500 text-sm">Authorize your profile via our secure portal.</p>
                                 </div>
                              </div>

                              <div className="flex flex-col gap-3 relative z-10">
                                 <div className="size-10 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center text-slate-500 font-bold">3</div>
                                 <div>
                                    <p className="text-slate-400 font-bold">Start Driving</p>
                                    <p className="text-slate-500 text-sm">Launch ACC and enter any track session.</p>
                                 </div>
                              </div>

                              <div className="hidden md:block absolute top-5 left-10 right-10 h-[2px] bg-slate-800 -z-0">
                                 <div className="w-1/3 h-full bg-primary shadow-[0_0_8px_#137fec]"></div>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div className="lg:col-span-5 flex flex-col gap-6">
                        <div className="bg-surface-dark border-l-4 border-primary rounded-r-xl p-8 h-full">
                           <div className="flex items-center gap-3 mb-6">
                              <span className="material-symbols-outlined text-primary">menu_book</span>
                              <h3 className="text-xl font-bold text-white uppercase tracking-tight">Quick Start Guide</h3>
                           </div>
                           <div className="space-y-8">

                              <section>
                                 <div className="flex items-center gap-2 mb-2">
                                    <span className="text-primary font-mono font-bold">01.</span>
                                    <h4 className="text-white font-semibold">Broadcasting Configuration</h4>
                                 </div>
                                 <p className="text-slate-400 text-sm mb-3">Ensure your ACC broadcasting settings are set to receive local telemetry packets. Locate your <code className="bg-black/50 px-1 rounded text-primary">broadcasting.json</code> file.</p>
                                 <div className="bg-black/40 rounded-lg p-4 font-mono text-xs text-slate-300 border border-slate-800 overflow-x-auto">
                                    <pre style={{whiteSpace: "pre-line"}}>{`{"updServerPort": 9000,"commandPassword": "acc","connectionPassword": "acc"}`}</pre>
                                 </div>
                              </section>

                              <section>
                                 <div className="flex items-center gap-2 mb-2">
                                    <span className="text-primary font-mono font-bold">02.</span>
                                    <h4 className="text-white font-semibold">Port Mapping</h4>
                                 </div>
                                 <p className="text-slate-400 text-sm mb-4">The client requires UDP access on the following ports for real-time synchronization:</p>
                                 <div className="grid grid-cols-2 gap-3">
                                    <div className="bg-slate-900/50 p-3 rounded border border-slate-800 flex justify-between items-center">
                                       <span className="text-xs text-slate-500 font-bold">UDP IN</span>
                                       <span className="text-sm text-white font-mono">9000</span>
                                    </div>
                                    <div className="bg-slate-900/50 p-3 rounded border border-slate-800 flex justify-between items-center">
                                       <span className="text-xs text-slate-500 font-bold">UDP OUT</span>
                                       <span className="text-sm text-white font-mono">9001</span>
                                    </div>
                                 </div>
                              </section>

                              <section>
                                 <div className="flex items-center gap-2 mb-2">
                                    <span className="text-primary font-mono font-bold">03.</span>
                                    <h4 className="text-white font-semibold">Common Issues</h4>
                                 </div>
                                 <ul className="space-y-3">
                                    <li className="flex gap-3 text-sm text-slate-400">
                                       <span className="material-symbols-outlined text-red-400 text-sm">cancel</span>
                                       <span>Firewall blocking sync client EXE.</span>
                                    </li>
                                    <li className="flex gap-3 text-sm text-slate-400">
                                       <span className="material-symbols-outlined text-red-400 text-sm">cancel</span>
                                       <span>Steam ID mismatch in dashboard.</span>
                                    </li>
                                 </ul>
                              </section>

                              <div className="pt-6 border-t border-slate-800 flex flex-col gap-3">
                                 <p className="flex items-center justify-between text-sm text-primary hover:underline">
                                    Full API Documentation
                                    <span className="material-symbols-outlined text-sm">open_in_new</span>
                                 </p>
                                 <p className="flex items-center justify-between text-sm text-slate-400 hover:text-white transition-colors">
                                    Join Discord Support
                                    <span className="material-symbols-outlined text-sm">forum</span>
                                 </p>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </main>
               <footer className="mt-auto border-t border-slate-800 bg-black/30 py-6 px-10">
                  <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
                     <p className="text-slate-500 text-xs">© 2023 ACCLiveTelemetry. Not affiliated with Kunos Simulazioni.</p>
                     <div className="flex gap-6">
                        <p className="text-slate-500 hover:text-white text-xs">Privacy Policy</p>
                        <p className="text-slate-500 hover:text-white text-xs">Terms of Service</p>
                        <p className="text-slate-500 hover:text-white text-xs">System Status</p>
                     </div>
                  </div>
               </footer>
               </div>
            </div>
         </>
      );
   }
}


export default DashboardError;